function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "17pyi0aupa",
  d: "M0 6c0 3.314 2.686 6 6 6s6-2.686 6-6-2.686-6-6-6-6 2.686-6 6z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-908.000000, -288.000000) translate(908.000000, 288.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "x2nn6r2xbb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#17pyi0aupa"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#06327F",
  d: "M-4.274 12.849L16.274 12.849 16.274 -0.849 -4.274 -0.849z",
  mask: "url(#x2nn6r2xbb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M3.752 8.45l-1.143.783-5.283 3.616h1.18l1.563-1.07v.02l4.076-2.78v3.83h.771V7.653l-.878.601-.286.196zm3.19 4.4h.723V9.017l4.076 2.782v-.02l1.563 1.07h2.324L9.2 8.45h1.526l5.547 3.797v-.61L11.62 8.45h4.654v-.978H6.942v5.377zm0-8.394l.214-.142.845-.561L14.745-.85h-.895L7.665 3.37v-4.22h-.723v5.305zM4.145 3.371L-2.04-.849h-2.137l6.743 4.602h-1.53L-4.273.128V.87L-.05 3.753h-4.224v.979h9.19V-.85h-.771v4.22zM1.083 9.233l1.143-.783.286-.196 1.144-.782h-7.93v.978H.19l-4.134 2.83-.33.226v1.343h.074L.07 9.927l1.013-.694zM16.274-.849L9.566 3.753l-1.43.979h8.138v-.98H11.86L16.274.74V-.85z",
  mask: "url(#x2nn6r2xbb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DC0928",
  d: "M10.664 4.732H8.136l1.43-.98 6.708-4.601h-1.53L8.002 3.753l-.845.56-.214.143V-.849H4.916v5.58h-9.19v2.74h7.93l-1.144.783-.286.196-1.143.783-1.014.694L-4.2 12.85h1.526l5.283-3.617 1.143-.783.286-.196.878-.6v5.196h2.026V7.472h9.332v-2.74h-5.61zm-8.098-.98L-4.177-.848h-.097v.977l5.31 3.625h1.53zM9.201 8.45l6.427 4.4h.646v-.603L10.727 8.45H9.201z",
  mask: "url(#x2nn6r2xbb)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.942 4.732L16.274 4.732 16.274 3.753 6.942 3.753zM-4.274 8.45L4.916 8.45 4.916 7.472-4.274 7.472z",
  mask: "url(#x2nn6r2xbb)"
}))));

function SvgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.239ffce9.svg";
export { ForwardRef as ReactComponent };